export default __webpack_public_path__ + "static/media/hero-5.3c22e573.jpg";